import { Home, Folder, Settings, HelpCircle, Star, LogOut, MessageCircle } from "lucide-react";
import posthog from "posthog-js";
import { useAuth } from "@/hooks/useAuth";
import { useTranslation } from "react-i18next";
import { AutoTranslate } from "@/lib/autoTranslate.tsx"
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarFooter,
} from "@/components/ui/sidebar";

const FEEDBACK_SURVEY_ID = "01a03fa3-a802-0000-fd09-35750e18a5aa";

/*
const items = [
  { title: "Resume Builder", url: "/", icon: Home },
  { title: "Saved Resumes", url: "/saved-resumes", icon: Folder },
  { title: "Settings", url: "/settings", icon: Settings },
  { title: "Help", url: "/help", icon: HelpCircle },
];*/

export function AppSidebar() {
  const transText = useTranslation().t('autoTranslate', { returnObjects: true });
  const { i18n } = useTranslation();


  const sidebarText = useTranslation().t('sidebar', { returnObjects: true })


  const items = [
    { id: "RB", title: sidebarText["resumeBuilder"], url: "/", icon: Home },
    { id: "SR", title: sidebarText["savedResumes"], url: "/saved-resumes", icon: Folder },
    { id: "Set", title: sidebarText["settings"], url: "/settings", icon: Settings },
    { id: "H", title: sidebarText["help"], url: "/help", icon: HelpCircle },
    { id: "Shr", title: sidebarText["shareSuccess"], url: "/share-success", icon: Star },
  ];
  const { signOut } = useAuth();

  const handleSignOut = async () => {

    await signOut();
  };

  const handleImproveClick = () => {
    posthog.onSurveysLoaded(() => {
      posthog.displaySurvey(FEEDBACK_SURVEY_ID, {
        displayType: "popover",
        position: "NextToTrigger",
        selector: "#submit-feedback-btn",
      });
    });
  };

  return (
    <Sidebar>
      <SidebarContent className="pb-2">
        <SidebarGroup className="mt-6">
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => {
                const isSavedResumes = item.id === "SR";
                const isSettings = item.id === "Set";

                return (
                  <SidebarMenuItem
                    key={item.title}
                    data-tour={isSavedResumes ? "saved-resumes" : isSettings ? "settings" : undefined}
                  >
                    <SidebarMenuButton asChild>
                      <a {...(("className" in item) && (item as { className?: string }).className ? { className: (item as { className?: string }).className } : {})} href={item.url}>
                        <item.icon />
                        <span>{item.title}</span>
                      </a>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
              <SidebarMenuItem>
                <SidebarMenuButton
                  id="submit-feedback-btn"
                  onClick={handleImproveClick}
                  className="sidebar-improve-button"
                >
                  <MessageCircle />
                  <span>Submit Feedback</span>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="shrink-0 border-t border-sidebar-border bg-sidebar p-3 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] shadow-[0_-8px_16px_rgba(0,0,0,0.04)] md:border-t-0 md:p-2 md:shadow-none">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              onClick={handleSignOut}
              size="lg"
              className="h-11 border border-sidebar-border bg-sidebar-accent/70 font-medium text-sidebar-foreground shadow-sm hover:bg-destructive/10 hover:text-destructive focus-visible:ring-2 focus-visible:ring-sidebar-ring md:h-8 md:border-transparent md:bg-transparent md:font-normal md:shadow-none"
              aria-label="Sign out"
            >
              <LogOut />
              <span>{AutoTranslate('Sign Out')}</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  );
}
